<template>
<div class="chapter">
<div class="inner_page">
<p class="sp" id="ded"> </p>
<p class="Dedication-ded"><span class="ePub-I">Dedicated to</span></p>
<p class="Dedication-ded">P<span class="ePub-SC">HILIP</span> B<span class="ePub-SC">ENNIS,</span></p>
<p class="Dedication-ded"><span class="ePub-I">Master Sergeant, USAF</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?33784b3c